function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(theme, direction) {
    var readingDirection = direction.readingDirection, start = direction.start, end = direction.end;
    var fieldsetStyle = _objectSpread({}, readingDirection, {
        all: 'initial',
        border: 'none',
        boxSizing: 'border-box',
        clear: 'both',
        color: theme.font.color.base,
        fontSize: theme.font.base.size.s,
        listStyleType: 'none',
        margin: 0,
        outline: 0,
        padding: 0,
        textAlign: start.direction
    });
    return {
        container: {
            display: 'inline-block'
        },
        fieldsetStyle: fieldsetStyle,
        legendStyle: {
            color: theme.font.color.base,
            fontFamily: theme.font.base.family,
            fontSize: theme.font.base.size.m
        },
        hiddenLegend: {
            position: 'absolute',
            clip: 'rect(0 0 0 0)'
        },
        inlineItems: {
            '& > label': _defineProperty({
                display: 'inline-flex'
            }, end.padding, theme.spacing[6])
        }
    };
};
export var useStyle = function(param) {
    var inline = param.inline, showLegend = param.showLegend, isRtl = param.isRtl;
    var ref;
    var ref1 = (ref = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref !== void 0 ? ref : {}, inlineItems = ref1.inlineItems, fieldsetStyle = ref1.fieldsetStyle, hiddenLegend = ref1.hiddenLegend, legendStyle = ref1.legendStyle, container = ref1.container;
    var fieldset = inline ? _objectSpread({}, fieldsetStyle, inlineItems) : fieldsetStyle;
    var legend = showLegend ? legendStyle : hiddenLegend;
    return {
        legend: legend,
        fieldset: fieldset,
        container: container
    };
};
